import { lazy } from 'react'
import { Navigate, Route } from 'react-router-dom'
import RoleGuard from './components/RoleGuard'

const ControllingLayout = lazy(() => import('./ControllingLayout'))
const ContoEconomico = lazy(() => import('./pages/ContoEconomico'))
const StatoPatrimoniale = lazy(() => import('./pages/StatoPatrimoniale'))
const Indici = lazy(() => import('./pages/Indici'))
const CEPerCassa = lazy(() => import('./pages/CEPerCassa'))
const RicaviLinee = lazy(() => import('./pages/RicaviLinee'))
const BudgetPipeline = lazy(() => import('./pages/BudgetPipeline'))
const Personale = lazy(() => import('./pages/Personale'))
const ImportBilancino = lazy(() => import('./pages/ImportBilancino'))
const Accessori = lazy(() => import('./pages/Accessori'))

/**
 * Sub-tree montato dentro App.jsx con path="/controlling/*" relative.
 * Le rotte interne sono relative al prefisso /controlling/.
 * L'accesso a ogni pagina è gated dal ruolo via RoleGuard.
 */
// La vecchia "Dashboard Direzione" è confluita nel Cruscotto direzionale
// (/cruscotto): l'indice del modulo parte dal Conto Economico, la prima pagina
// accessibile sia ai soci sia ai PM.

export function controllingRoutes() {
  return (
    <Route path="/" element={<ControllingLayout />}>
      <Route index element={<Navigate to="conto-economico" replace />} />
      {/* vecchio indirizzo: i segnalibri portano al cruscotto unificato */}
      <Route path="direzione" element={<Navigate to="/cruscotto" replace />} />
      <Route
        path="conto-economico"
        element={
          <RoleGuard allow={['partner', 'pm']}>
            <ContoEconomico />
          </RoleGuard>
        }
      />
      <Route
        path="ce-cassa"
        element={
          <RoleGuard allow={['partner']}>
            <CEPerCassa />
          </RoleGuard>
        }
      />
      <Route
        path="stato-patrimoniale"
        element={
          <RoleGuard allow={['partner']}>
            <StatoPatrimoniale />
          </RoleGuard>
        }
      />
      <Route
        path="indici"
        element={
          <RoleGuard allow={['partner']}>
            <Indici />
          </RoleGuard>
        }
      />
      <Route
        path="ricavi-linee"
        element={
          <RoleGuard allow={['partner', 'pm']}>
            <RicaviLinee />
          </RoleGuard>
        }
      />
      <Route
        path="budget"
        element={
          <RoleGuard allow={['partner', 'pm']}>
            <BudgetPipeline />
          </RoleGuard>
        }
      />
      <Route
        path="personale"
        element={
          <RoleGuard allow={['partner']}>
            <Personale />
          </RoleGuard>
        }
      />
      <Route
        path="import"
        element={
          <RoleGuard allow={['partner']}>
            <ImportBilancino />
          </RoleGuard>
        }
      />
      <Route
        path="accessori"
        element={
          <RoleGuard allow={['partner']}>
            <Accessori />
          </RoleGuard>
        }
      />
      {/* URL sconosciuto sotto /controlling/* → torna al Conto Economico
          invece di lasciare la pagina bianca. */}
      <Route path="*" element={<Navigate to="conto-economico" replace />} />
    </Route>
  )
}
